import React from "react"

import { withMain } from "./withMain"

export const Main = withMain(({ children }): JSX.Element => <main>{children}</main>)
